import { IntlProvider } from 'react-intl';
import { setLocale } from 'yup';
import * as Yup from 'yup';
import messages from './../../../i18n/base-en';

const getValidationSchema = (intlData: IntlProvider.Props) => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  setLocale({
    mixed: {
      required: formatMessage(messages.required_valid_error)
    },
    string: {
      email: formatMessage(messages.email_valid_error)
    }
  });

  const recovery = Yup.object().shape({
    email: Yup.string()
      .email()
      .required(),
  });

  return Yup.object().shape({ recovery });

};

export default getValidationSchema;
